"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderHeaderStatus = void 0;
var SalesOrderHeaderStatus;
(function (SalesOrderHeaderStatus) {
    SalesOrderHeaderStatus["NEW"] = "new";
    SalesOrderHeaderStatus["ACKNOWLEDGED"] = "acknowledged";
    SalesOrderHeaderStatus["LINES_SUBMITTED"] = "submitted";
    SalesOrderHeaderStatus["CLOSED"] = "closed";
    SalesOrderHeaderStatus["DELETED"] = "deleted";
    SalesOrderHeaderStatus["DUPLICATE"] = "duplicate";
})(SalesOrderHeaderStatus = exports.SalesOrderHeaderStatus || (exports.SalesOrderHeaderStatus = {}));
//# sourceMappingURL=sales-order-header-status.enum.js.map